import { Injectable } from '@angular/core';
import { concatMap, map, toArray } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Observable ,  from } from 'rxjs';

export enum PayrollCycleType {
  All = 0,
  OnCycle = 1,
  OffCycle = 2
}

export class PayrollTypeInfo {
  value: PayrollCycleType;
  key: string;
  localizedName: string;

  // TODO: replace numbers with Ssp PayrollType enum
  get paySequences(): number[] {
    switch (this.value) {
      case PayrollCycleType.All:
        return null;
      case PayrollCycleType.OnCycle:
        return [1];
      case PayrollCycleType.OffCycle:
        return [2, 3, 4, 5, 6, 7, 8, 9];
    }

    return null;
  }

  constructor(value: number) {
    this.value = value;
    this.key = PayrollTypeInfo.getKey(this.value);
  }

  public static getKey(payrollType: number) {
    switch (payrollType) {
      case 0:
        return 'AT_A_GLANCE.PAYROLL_TYPE_ALL';
      case 1:
        return 'AT_A_GLANCE.PAYROLL_TYPE_REGULAR';
      case 2:
        return 'AT_A_GLANCE.PAYROLL_TYPE_OFFCYCLE';
      default:
        return 'AT_A_GLANCE.PAYROLL_TYPE_UNKNOWN';
    }
  }

  withLocalizedName(localizedName: string) {
    this.localizedName = localizedName;
    return this;
  }
}

@Injectable()
export class PayrollTypeService {
  allPayrollTypeValues = [0, 1, 2];
  allPayrollTypes: PayrollTypeInfo[];

  constructor(private _translateService: TranslateService) { }

  getPayrollTypes(): Observable<PayrollTypeInfo[]> {
    this.allPayrollTypes = this.allPayrollTypeValues.map(value => new PayrollTypeInfo(value));

    return from(this.allPayrollTypes)
      .pipe(
        concatMap(
          info => this._translateService.get(info.key)
        ),
        map(
          (localizedName, i) => this.allPayrollTypes[i].withLocalizedName(localizedName)
        ),
        toArray()
      );
  }
}
